<template>
  <div class="rideRecordsBox">
    <div class="panel_head">
      <span>|&nbsp;購買記錄</span>
    </div>
    <div class="com_box">
      <div class="com_head">
        <span style="margin-left: .30rem;margin-right: .12rem;font-size: .16rem;color: #666;">(公眾號)會員ID</span>
        <el-input
          class="idBox"
          placeholder="請輸入(公眾號)會員ID"
          v-model="personnelCode"
          style="width: 2.50rem;"
          clearable>
        </el-input>

        <span style="margin-left: .30rem;margin-right: .12rem;font-size: .16rem;color: #666;">日期範圍</span>
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="開始日期"
          end-placeholder="結束日期">
        </el-date-picker>

        <!--搜索框-->
        <!--<div class="searchInput" v-show="reportType=='1'&&orderList.length!=0">
            <el-input
                placeholder="請輸入搜索條件"
                v-model="search_index"
                style="width: 2.00rem;"
                clearable>
            </el-input>
        </div>
        <div class="searchInfoInput" v-show="reportType=='2'&&orderInfoList.length!=0">
            <el-input
                placeholder="請輸入搜索條件"
                v-model="search_info_index"
                style="width: 2.00rem;"
                clearable>
            </el-input>
        </div>-->

        <!--        <div class="import_btn none" @click="importExcel">導入員工信息EXCEL</div>-->

        <!--        <el-upload-->
        <!--          class="upload_btn"-->
        <!--          name="files"-->
        <!--          :action="uploadUrl"-->
        <!--          :on-preview="handlePreview"-->
        <!--          :on-remove="handleRemove"-->
        <!--          :on-success="importExcelFinish"-->
        <!--          :before-remove="beforeRemove"-->
        <!--          :multiple="false"-->
        <!--          :limit="1"-->
        <!--          :on-exceed="handleExceed"-->
        <!--          :with-credentials="true"-->
        <!--          :show-file-list="false"-->
        <!--          :file-list="fileList"-->
        <!--          :data="{companyCode:$store.state.userInfo.company_code}">-->
        <!--          <el-button size="small" type="primary" class="import_btn">導入員工信息EXCEL</el-button>-->
        <!--          &lt;!&ndash;          <div slot="tip" class="el-upload__tip">只能上傳jpg/png文件，且不超過500kb</div>&ndash;&gt;-->
        <!--        </el-upload>-->

        <!--        <div class="add_btn" @click="dialogsStatus='new';dialogShowHideEvent()">新增</div>-->

        <div class="export_btn" @click="exportExcel">導出EXCEL</div>
        <div class="query_btn" @click="queryForm">立即查詢</div>

      </div>
      <div class="tableBox" ref="tableBox">
        <table>
          <!--正常表頭-->
          <thead ref="tableFixedHead">
          <tr>
            <th style="width: 200px">員工公司名稱</th>
            <th style="width: 200px">員工姓名</th>
            <th style="width: 200px">職工編碼</th>
            <th style="width: 200px">(公眾號)會員ID</th>
            <th style="width: 200px">檢票時間</th>
            <th style="width: 300px">檢票站點</th>
            <th style="width: 320px">線路名稱</th>
            <th style="width: 200px">設備名稱</th>
            <!--            <th style="width: 200px">班次號碼</th>-->
            <th style="width: 200px">班次日期</th>
            <th style="width: 200px">發車時間</th>
            <th style="width: 200px">購買月份</th>
            <!--            <th style="width: 200px">票號</th>-->
            <!--            <th style="width: 200px">檢票序號</th>-->
          </tr>
          </thead>
          <tbody v-if="isLoaded&&showDataArr.length<=0">
          <div class="noData">沒有數據</div>
          </tbody>
          <tbody v-if="showDataArr.length>0">
          <tr v-for="u in showDataArr">
            <td>{{ u.personnelCompany }}</td>
            <td>{{ u.personnelName }}</td>
            <td>{{ u.personnelWorkCard }}</td>
            <td>{{ u.personnelCode }}</td>
            <td>{{ u.checkTime }}</td>
            <td>{{ u.checkStation }}</td>
            <td>{{ u.lineName }}</td>
            <td>{{ u.equipmentName }}</td>
            <!--            <td>{{ u.classNum }}</td>-->
            <td>{{ u.classDate }}</td>
            <td>{{ u.classTime }}</td>

            <td>{{ u.saleMonth }}</td>
            <!--            <td>{{ u.ticketNum }}</td>-->
            <!--            <td>{{ u.CheckNo }}</td>-->
          </tr>
          </tbody>
        </table>

        <table id="excelTable" class="none">
          <!--正常表頭-->
          <thead ref="tableFixedHead">
          <tr>
            <th style="width: 200px">員工公司名稱</th>
            <th style="width: 200px">員工姓名</th>
            <th style="width: 200px">職工編碼</th>
            <th style="width: 200px">(公眾號)會員ID</th>
            <th style="width: 200px">檢票時間</th>
            <th style="width: 300px">檢票站點</th>
            <th style="width: 320px">線路名稱</th>
            <th style="width: 200px">設備名稱</th>
            <!--            <th style="width: 200px">班次號碼</th>-->
            <th style="width: 200px">班次日期</th>
            <th style="width: 200px">發車時間</th>
            <th style="width: 200px">購買月份</th>
            <!--            <th style="width: 200px">票號</th>-->
            <!--            <th style="width: 200px">檢票序號</th>-->
          </tr>
          </thead>
          <tbody v-if="allDataArr.length>0">
          <tr v-for="u in allDataArr">
            <td>{{ u.personnelCompany }}</td>
            <td>{{ u.personnelName }}</td>
            <td>{{ u.personnelWorkCard }}</td>
            <td>{{ u.personnelCode }}</td>
            <td>{{ u.checkTime }}</td>
            <td>{{ u.checkStation }}</td>
            <td>{{ u.lineName }}</td>
            <td>{{ u.equipmentName }}</td>
            <!--            <td>{{ u.classNum }}</td>-->
            <td>{{ u.classDate }}</td>
            <td>{{ u.classTime }}</td>

            <td>{{ u.saleMonth }}</td>
            <!--            <td>{{ u.ticketNum }}</td>-->
            <!--            <td>{{ u.CheckNo }}</td>-->
          </tr>
          </tbody>
        </table>

      </div>
      <div class="page_box" v-show="allDataArr.length>10">
        <div class="block">
          <el-pagination
            layout="prev, pager, next"
            @current-change="pageChange"
            :current-page="currentPage"
            :total="allDataArr.length">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FileSaver from 'file-saver'
import XLSX from 'xlsx'

export default {
  data()
  {
    return {
      //加載完成
      isLoaded: false,
      //員工乘車碼
      personnelCode: "",
      //所有表數據
      allDataArr: [],
      //顯示的員工信息
      showDataArr: [],
      //分批的數據
      batchDataInfo: {},
      //當前頁碼
      currentPage: 1,
      //頁面顯示行數
      pageSize: 10,
      //總頁數
      pageCount: 0,
      //日期範圍
      dateRange: [],
    }
  },
  async created()
  {
    this.init()
    //請求用戶數據
    await this.queryData()
    //加載完成
    this.isLoaded = true
  },
  methods: {
    //初始化數據
    init()
    {
      // 默認1個月
      let endDate = new Date()
      let t = (endDate.getTime() - 2592000000).toFixed(0)
      let beginDate = new Date(Number(t))
      this.dateRange[0] = this.getDatetime(beginDate.getTime()).dateTime
      this.dateRange[1] = this.getDatetime(endDate.getTime()).dateTime
    },
    async queryForm()
    {
      await this.queryData({
        personnelCode: this.personnelCode,
        beginTime: this.dateRange ? this.dateRange[0] + " 00:00:00" : undefined,
        endTime: this.dateRange ? this.dateRange[1] + " 23:59:59" : undefined,
      })
    },
    //導出excel
    async exportExcel()
    {
      // 如果沒有數據，不導出
      if(this.allDataArr.length <= 0)
      {
        this.$message({
          message: "沒有數據，不導出",
          type: "warning",
        })
        return
      }

      this.$nextTick(function()//等待table數據更新渲染
      {
        let fileName = "乘車記錄"

        /* generate workbook object from table */
        let wb = XLSX.utils.table_to_book(document.querySelector('#excelTable'), {raw: true})
        /* get binary string as output */
        let wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'})
        try
        {
          FileSaver.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), fileName + '.xlsx')
        } catch(e)
        {
          if(typeof console !== 'undefined')
          {
            console.log(e, wbout)
          }
        }
        return wbout;
      })
    },
    pageChange(pageNo)
    {
      this.showDataArr = this.batchDataInfo[pageNo]
      this.$forceUpdate()
    },
    //請求數據
    async queryData(params = {})
    {
      //初始化
      this.allDataArr = []
      this.showDataArr = []
      this.batchDataInfo = {}

      //當前公司編碼
      let companyCode = this.$store.state.userInfo.company_code

      //參數
      params = {
        beginTime: this.dateRange ? this.dateRange[0] : undefined,
        endTime: this.dateRange ? this.dateRange[1] : undefined,
        companyCode,
        ...params,
      }
      //查詢用戶數據
      let res = await this.axios.post(this.IP + this.PATH + '/personne/personnel.product.check.detail.report', params)

      //賦值
      this.allDataArr = res.data.responseData

      //沒數據返回
      if(this.allDataArr.length <= 0)
      {
        return
      }

      // this.allDataArr.push(...this.allDataArr)
      // this.allDataArr.push(...this.allDataArr)
      // this.allDataArr.push(...this.allDataArr)

      //總共頁數
      this.pageCount = Math.ceil(this.allDataArr.length / this.pageSize)

      //當前頁號
      let pageNo = 1
      //分批數據
      for(let i = 0; i < this.allDataArr.length; i++)
      {
        if(i > this.pageSize * pageNo - 1)
        {
          pageNo += 1
        }

        if(this.batchDataInfo[pageNo])
        {
          this.batchDataInfo[pageNo].push(this.allDataArr[i])
        }
        else
        {
          this.batchDataInfo[pageNo] = [this.allDataArr[i]]
        }
      }

      this.showDataArr = this.batchDataInfo[this.currentPage]

      //刷新界面
      this.$forceUpdate()
    },
  },
}
</script>
<style lang="less">
.rideRecordsBox {
  .panel_head {
    margin: .1rem 0;
  }

  .panel_head:after {
    content: '';
    display: block;
    overflow: hidden;
    clear: both;
  }

  .panel_head > span {
    float: left;
    margin-left: .83rem;
    font-size: .24rem;
  }

  .panel_head > div {
    width: .85rem;
    height: .30rem;
    line-height: .30rem;
    text-align: center;
    background-color: transparent;
    color: #000;
    display: inline-block;
    cursor: pointer;
    margin-left: .15rem;
    margin-top: .03rem;
  }

  .panel_head > div.active {
    background-color: #1e7feb;
    color: #fff;
  }

  .com_box {
    padding: 0 2% .5rem 2%;
    background-color: #fff;
    background-clip: content-box;
    min-height: 7rem;
    //margin-bottom: .30rem;
    position: relative;
  }

  .com_box::-webkit-scrollbar {
    display: none;
  }

  .com_box .com_head {
    padding-left: .1rem;
    padding-top: .20rem;
    padding-bottom: .20rem;
  }

  /*重寫搜索欄組件樣式*/

  .com_box .com_head .payTypeBox /deep/ .el-input__icon {
    font-size: .14rem;
    line-height: .4rem;
  }

  .com_box .com_head .payTypeBox /deep/ .el-input__inner {
    width: 2rem;
    height: .4rem;
    font-size: .14rem;
  }

  .com_box .com_head .idBox /deep/ .el-input__icon {
    font-size: .14rem;
    line-height: .4rem;
  }

  .com_box .com_head .idBox /deep/ .el-input__inner {
    width: 2rem;
    height: .4rem;
    font-size: .14rem;
  }

  .com_box .com_head .sumDateBox {
    width: 3.5rem;
    height: .4rem;
    padding: 0.03rem 0.1rem;
  }

  .com_box .com_head .sumDateBox /deep/ .el-range__icon {
    line-height: .32rem;
  }

  .com_box .com_head .sumDateBox /deep/ .el-range-separator {
    padding: 0 0.05rem;
    line-height: .32rem;
    font-size: .14rem;
    width: 8%;
  }

  .com_box .com_head .sumDateBox /deep/ .el-range-input {
    font-size: .14rem;
  }

  .com_box .com_head .detailDateBox {
    width: 3.8rem;
    height: .4rem;
    padding: 0.03rem 0.1rem;
  }

  .com_box .com_head .detailDateBox /deep/ .el-range__icon {
    line-height: .32rem;
  }

  .com_box .com_head .detailDateBox /deep/ .el-range-separator {
    padding: 0 0.05rem;
    line-height: .32rem;
    font-size: .14rem;
    width: 8%;
  }

  .com_box .com_head .detailDateBox /deep/ .el-range-input {
    font-size: .14rem;
  }

  .com_box .com_head .chargeNoBox /deep/ .el-input__inner {
    width: 2rem;
    height: .4rem;
    font-size: .14rem;
  }

  .com_box .com_head .chargeNoBox /deep/ .el-input__icon {
    font-size: .14rem;
    line-height: .4rem;
  }

  .com_box .com_head .query_btn {
    display: inline-block;
    border-radius: 3px;
    background-color: #e29a33;
    margin-top: .05rem;
    float: right;
    color: #fff;
    cursor: pointer;
    width: 1.5rem;
    height: .40rem;
    font-size: .18rem;
    line-height: .40rem;
    text-align: center;
    margin-left: .30rem;
    vertical-align: middle;
    margin-right: .5rem;
    font-weight: normal;
  }

  .com_box .com_head .export_btn {
    display: inline-block;
    border-radius: 3px;
    background-color: #3d61b1;
    margin-top: .05rem;
    float: right;
    color: #fff;
    cursor: pointer;
    width: 1.5rem;
    height: .40rem;
    font-size: .18rem;
    line-height: .40rem;
    text-align: center;
    margin-left: .30rem;
    vertical-align: middle;
    margin-right: .5rem;
    font-weight: normal;
  }

  .com_box .com_head .add_btn {
    display: inline-block;
    border-radius: 3px;
    background-color: #1657da;
    margin-top: .05rem;
    float: right;
    color: #fff;
    cursor: pointer;
    width: 1.00rem;
    height: .40rem;
    font-size: .18rem;
    line-height: .40rem;
    text-align: center;
    margin-left: .30rem;
    vertical-align: middle;
    margin-right: .2rem;
    font-weight: normal;
  }

  .com_box .com_head .check_btn.active {
    position: absolute;
    top: -.50rem;
    right: 1.50rem;
  }

  .com_box .com_head .searchInput {
    position: absolute;
    top: -.6rem;
    right: .66rem;
  }

  .com_box .com_head .searchInput /deep/ .el-input__icon {
    font-size: .14rem;
    line-height: .4rem;
  }

  .com_box .com_head .searchInput /deep/ .el-input__inner {
    width: 2rem;
    height: .4rem;
    font-size: .14rem;
  }

  .com_box .com_head .searchInfoInput {
    position: absolute;
    top: -.6rem;
    right: 3rem;
  }

  .com_box .com_head .searchInfoInput /deep/ .el-input__icon {
    font-size: .14rem;
    line-height: .4rem;
  }

  .com_box .com_head .searchInfoInput /deep/ .el-input__inner {
    width: 2rem;
    height: .4rem;
    font-size: .14rem;
  }

  .com_box .upload_btn {
    display: inline-block;
    float: right;
    margin-right: .1rem;
  }

  .com_box .com_head .import_btn {
    margin-right: .30rem;
    display: inline-block;
    background-color: #30976d;
    border: none;
    float: right;
    color: #fff;
    cursor: pointer;
    height: .40rem;
    font-size: .18rem;
    line-height: .40rem;
    text-align: center;
    vertical-align: middle;
    font-weight: normal;
    padding: 0 .2rem;
    margin-top: .05rem;
  }

  .com_box .com_head .export_btn.active {
    position: absolute;
    top: -.50rem;
    right: .20rem;
  }

  .com_box .tableBox {
    //width: 100%;
    height: 6.3rem;
    overflow-y: scroll;
  }

  .com_box .tableBox table {
    //width: 100%;
    box-sizing: border-box;
    border-spacing: 0;
  }

  .com_box .tableBox table thead {
    background-color: #2b5787;
    color: #fff;
    height: .55rem;
  }

  .tableBox {
    table {
      width: 2000px;
      overflow: scroll;

      tbody {
        position: static;

        tr {
          &:hover {
            background-color: rgb(225, 225, 225) !important;
          }

          th {
            text-align: center;
          }

          td {
            text-align: center;
            border-bottom: solid 1px #ccc;

            .editBtn {
              cursor: pointer;
              padding: 0 .05rem;
              color: #35bc45;
              //border-bottom: solid 1px #35bc45;
              //padding-bottom: .03rem;
            }

            .delBtn {
              cursor: pointer;
              color: #f0435b;
              padding-right: .05rem;
              text-underline: #f0435b;
              //border-bottom: solid 1px #f0435b;
              //padding-bottom: .03rem;
            }
          }
        }

        .noData {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -200%);
        }
      }
    }
  }

  /*固定表頭*/

  .com_box .fixHeadBox {
    width: 100%;
    padding: 0 2.5%;
    position: absolute;
    top: 0.8rem;
    left: 0;
  }

  .com_box .fixHead {
    background-color: #2b5787;
    background-clip: content-box;
    color: #fff;
    width: 100%;
    padding-right: .17rem;
  }

  .com_box .fixHead tr th {
    height: .50rem;
    line-height: .5rem;
    //text-align: left;
  }

  /*正常表格*/

  .com_box .tableBox table thead tr th {
    height: .50rem;
    //text-align: left;
  }

  .com_box .tableBox table thead tr th:first-of-type {
    //padding-left: .50rem;
  }

  .com_box .tableBox table thead tr th:last-of-type {
    //padding-right: .30rem;
  }

  .com_box .tableBox table tbody tr td:first-of-type {
    //padding-left: .50rem;
  }

  .com_box .tableBox table tbody tr td:last-of-type {
    //padding-right: .30rem;
  }

  .com_box .tableBox table tbody tr {
    height: .55rem;
    font-size: .18rem;
    text-align: left;
  }

  .com_box .tableBox table tbody tr:nth-of-type(2n) {
    background-color: #fbfbfb;
  }

  .com_box .tableBox .money {
    font-size: .28rem;
  }

  .com_box .tableBox .money span {
    font-size: .18rem;
  }

  .com_box .page_box {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: .1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ride_records/index.vue